<div>
  <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12 m-t-70 p-0">
    <div class="card m-b-15">
      <div class="card-body">
        <div class="row content__grid">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <div class="page-title-box">
              <div class="row align-items-center">
                <div class="col-sm-12 col-md-12 col-sm-12 col-12">
                  <h4 class="page-title content__title text-center f-s-20">Cronograma <span class="hide-xs">de
                      salidas</span>:<span class="m-l-7">{{date_range}}</span> </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row justify-content-md-center p-l-15 p-r-15">
          <!-- <button class="btn btn-light m-b-10"><i class="fas fa-filter m-r-3"></i>Filtros</button> -->
          <div class="content__subhead__inputGrid m-b-10 m-r-10" style="display: inline-flex;">            
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text content__subhead__inputGrid__title">
                  <span class="m-r-5">G. Trabajo</span>
                  <span data-toggle="tooltip" data-placement="right"
                        data-original-title="Solo se listarán en cronograma únicamente las reservas asociadas al grupo de trabajo seleccionado"><i
                          class="fas fa-info-circle f-s-14"></i></span>
                </span>
              </div> 
              <select class="form-control content__subhead__inputGrid__input" [(ngModel)]="workinggroup_id" style="height: 32px;"
              (change)="changeworkingGroup()">
                <option value="null">Todos</option>
                  <option *ngFor="let item of workinggroups" [value]="item.id">{{ item.description }}</option>
              </select>
            </div>
          </div>
          <div class="content__subhead__inputGrid m-b-10 m-r-10" style="display: inline-flex;">            
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text content__subhead__inputGrid__title">
                  <span class="m-r-5">Elegir fecha</span><i class="far fa-calendar-alt"></i>
                </span>
              </div>
              <input type="text" id="date_range" [(ngModel)]="date_range"
                class="form-control text-center content__subhead__inputGrid__input" style="height: 32px;">
              <div class="input-group-append">
                <span class="input-group-text content__subhead__inputGrid__title pointer" (click)="refresh()">
                  <i class="fas fa-undo"></i>
                </span>
              </div>
            </div>
          </div>
          <button class="btn btn-light m-b-10" data-toggle="modal"
          data-target="#openExtendsScheduleProjection" (click)="scheduleProjection()"><i class="fas fa-chart-line m-r-3"></i>Proyección</button>
        </div>
        <div class="row m-t-15">
          <div class="col-12 text-left m-b-15">
            <span *ngIf="check_totals > 0" class="badge badge-dark f-s-11 p-5 m-r-10">Programados: {{check_totals}}
              PAX</span>
          </div>
          <ng-container *ngIf="items.length > 0">
            <ng-container *ngFor="let item of items">
              <div class="col-lg-3 col-md-3 col-12 cronograma__content_item" *ngIf="item.total > 0">
                <div class="card" style="height: 90%;">
                  <a class="col-lg-12 cronograma__item" (click)="viewdetail(item)" data-toggle="modal"
                    data-target="#openExtendsScheduleDetail">
                    <p class="cronograma__item__nombre">{{item.description}}</p>
                    <p class="cronograma__item__pasajero">
                      <span class="m-r-5">{{item.total}}</span>
                      <span class="m-r-5">PASAJEROS</span>
                      <i class="fa fa-users"></i>
                    </p>
                    <p class="m-b-0">                      
                      <span class="badge badge-info cronograma__item__badge">Compartidos
                        {{item.vehicle_shared}} pax</span>
                    </p>
                    <p class="m-b-5" *ngIf="item.vehicle_private > 0">
                      <span class="badge badge-warning cronograma__item__badge cronograma__item__badge_warning badge-schedule-private">
                        Privados <span class="f-s-11">{{item.vehicle_private}} pax</span></span>
                    </p>
                    <p class="cronograma__item__link m-t-5" style="font-weight: 600;">Click ver detalles</p>
                  </a>
                </div>
              </div>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="check_totals == 0">
            <div class="col-12">
              <p class="f-s-14 m-t-10 m-b-15">No se encontraron salidas para la <b>fecha seleccionada <i
                    class="far fa-calendar"></i></b></p>
            </div>
          </ng-container>
          <ng-container *ngIf="tours_open.length > 0">
            <div class="m-t-20 col-12">
              <p><i class="fas fa-info-circle m-r-5"></i><span class="text-open">Reservas abiertas</span>
                (Pendientes de asignar fecha)</p>
              <div class="row">
                <div class="col-lg-6">
                  <div class="card m-b-15">
                    <a class="col-lg-12 cronograma__item" (click)="viewToursOpen()" data-toggle="modal"
                      data-target="#openExtendsScheduleOpen">
                      <span *ngFor="let summary of tours_open" class="m-r-5">
                        <span class="bold">{{summary.description}}</span> ({{summary.total}} pax),
                      </span>
                      <p class="cronograma__item__link m-t-5" style="font-weight: 600;">Click ver detalles</p>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="transfers.length > 0">
            <div class="m-t-20 m-b-20 col-12">
              <p class="m-b-10"><i class="fas fa-arrows-alt-h m-r-5"></i><span class="bold">Traspasos realizados</span>
              </p>
              <div class="row">
                <div class="col-lg-12">
                  <div class="table-responsive">
                    <table class="table table-hover mb-0 table-sm">
                      <thead class="thead-default">
                        <tr>
                          <th>Agencia Operadora</th>
                          <th>Tours</th>
                          <th>N° origen reserva</th>
                          <th>Etiqueta</th>
                          <th>Reponsable</th>
                          <th class="text-center">N° pax</th>
                          <th class="text-center">Cobro delegado</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngIf="transfers.length == 0">
                          <td colspan="2"><span>No se encontraron registros</span></td>
                        </ng-container>
                        <ng-container *ngIf="transfers.length > 0">
                          <tr *ngFor="let item of transfers; let i = index">
                            <td>
                              <span class="bold">{{item.agency_operator.tradename}}</span>
                            </td>
                            <td>
                              <span class="bold">{{item.name_tours}}</span>
                            </td>
                            <td>
                              <i *ngIf="item.is_favorite" class="fas fa-star m-r-2 color-favorite"></i>
                              {{item.code}}
                            </td>
                            <td>
                              {{item.reference_voucher}}
                            </td>
                            <td>
                              {{item.client_fullname}}
                            </td>
                            <td class="text-center">
                              {{item.nro_pax}}
                            </td>
                            <td class="text-center">
                              {{item.delegated_payment | currency:'S/ '}}
                            </td>
                            <td>
                              <div *ngIf="item.is_paid">
                                <span  class="badge badge-dark f-s-10">Reportado</span>
                              </div>
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="tours_finish.length > 0">
            <div class="m-t-20 col-12">
              <p><i class="fas fa-plane-departure m-r-5"></i><span class="text-open">Reservas que finalizan el
                  ({{date_range | date: 'mediumDate'}})</span></p>
              <div class="row">
                <div class="col-lg-12">
                  <div class="table-responsive">
                    <table class="table table-hover mb-0 table-sm">
                      <thead class="thead-default">
                        <tr>
                          <th>N° reserva</th>
                          <th>Etiqueta</th>
                          <th>Reponsable</th>
                          <th class="text-center">N° pax</th>
                          <th>Teléfonos</th>
                          <th>Deuda</th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngIf="tours_finish.length == 0">
                          <td colspan="2"><span>No se encontraron registros</span></td>
                        </ng-container>
                        <ng-container *ngIf="tours_finish.length > 0">
                          <tr *ngFor="let item of tours_finish; let i = index">
                            <td>
                              <a class="grid__link bold" (click)="bookingDetail(item)" data-toggle="modal"
                                data-target="#openExtendsBookingsDetail">
                                <i *ngIf="item.is_favorite" class="fas fa-star m-r-2 color-favorite"></i>
                                {{item.code}}
                              </a>
                            </td>

                            <td>
                              {{item.reference_voucher}}
                            </td>
                            <td>
                              <p class="m-b-0">{{item.client_data.fullname}}</p>
                              <p class="bold f-s-10 m-b-0">{{item.client_data.typeDocument}} :
                                {{item.client_data.document}}</p>
                            </td>
                            <td class="text-center">
                              {{item.nro_pax}}
                            </td>
                            <td>
                              <div>{{item.client_data.cellphone}}</div>
                              <div *ngIf="item.client_data.telephone != null">
                                {{item.client_data.telephone}}
                              </div>
                            </td>
                            <td>
                              <span class="text-danger bold">
                                {{item.total - item.total_paid | currency:"S/ "}}
                              </span>
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
        <div class="row m-t-20" *ngIf="items.length == 0">
          <div class="col-12 cronograma__empty">
            <i class="fa fa-calendar cronograma__empty__icon"></i>
            <h3 class="f-s-16">No se encuentra resultados.</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-bookings-detail-extends></app-bookings-detail-extends>
<app-schedule-detail (onTransferEvent)="loadAfterTransfer($event)"></app-schedule-detail>
<app-schedule-open></app-schedule-open>
<app-schedule-projection></app-schedule-projection>

